import { render } from "./ThankYouPageBLG.vue?vue&type=template&id=d5d6ef58&scoped=true"
import script from "./ThankYouPageBLG.vue?vue&type=script&lang=js"
export * from "./ThankYouPageBLG.vue?vue&type=script&lang=js"

import "./ThankYouPageBLG.vue?vue&type=style&index=0&id=d5d6ef58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5d6ef58"]])

export default __exports__